import { isAdmin, isAgent, isFactored, userType } from '../constants';
import { Images } from '../images';
import { PermissionsList } from '../hooks';
import { RolePermission } from '../hooks';
import { branchManager, officeManager } from '../hooks/roleHooks';


// export const ProfileRouters =
//   [
//     userType === 'ADMIN' &&
//     RolePermission([PermissionsList.READ_ADMIN?.code, PermissionsList.CREATE_UPDATE_ADMIN?.code]) &&
//     {
//       'name': 'HR',
//       'icon': Images.humanResourcesGray,
//       'activeIcon': Images.humanResources,
//       'path': '/humanResources',
//       'create': '/createHumanResources',
//       'type': 'Profile',
//     },
//     RolePermission([PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code], 'officeManager') &&
//     {
//       'name': 'Offices',
//       'icon': Images.officesGray,
//       'activeIcon': Images.offices,
//       'path': '/offices',
//       'create': '/createOffice',
//       'info': '/offices',
//       'type': 'Profile',
//     },
//     RolePermission([PermissionsList.READ_BRANCH?.code, PermissionsList.CREATE_UPDATE_BRANCH?.code], 'officeOrBranchManager') &&
//     {
//       'name': 'Branches',
//       'icon': Images.branchesGray,
//       'activeIcon': Images.branches,
//       'path': '/branches',
//       'create': '/createBranch',
//       'type': 'Profile',
//     },
//     RolePermission([PermissionsList?.READ_AGENT?.code, PermissionsList.CREATE_UPDATE_AGENT?.code], 'officeOrBranchManager') &&
//     {
//       'name': 'Agents',
//       'icon': Images.agentsGray,
//       'activeIcon': Images.agentsFill,
//       'path': '/agents',
//       'create': '/createAgent',
//       'type': 'Profile',
//     },
//     RolePermission([PermissionsList.READ_MC?.code, PermissionsList.CREATE_UPDATE_MC?.code]) &&
//     {
//       'name': 'Authorities',
//       'icon': Images.authorityGray,
//       'activeIcon': Images.authorityFill,
//       'path': '/authorities',
//       'create': '/createAuthorities',
//       'type': 'Profile',
//     },
//     userType === 'ADMIN' &&
//     RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) &&
//     {
//       'name': 'Customers',
//       'icon': Images.customerGray,
//       'activeIcon': Images.customerFill,
//       'path': '/customers',
//       'create': '/createCustomer',
//       'type': 'Profile',
//     },
//     RolePermission([PermissionsList?.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code], 'agentView') &&
//     {
//       'name': 'Carriers',
//       'icon': Images.carrierGray,
//       'activeIcon': Images.carrierFill,
//       'path': '/carriers',
//       'create': '/createCarriers',
//       'type': 'Profile',
//     },
//     userType === 'ADMIN' &&
//     RolePermission([PermissionsList.READ_FACTORING?.code, PermissionsList.CREATE_UPDATE_FACTORING?.code]) &&
//     {
//       'name': 'Factorings',
//       'icon': Images.factoringGray,
//       'activeIcon': Images.factoring,
//       'path': '/factorings',
//       'create': '/createFactoring',
//       'type': 'Profile',
//     },
//   ];


// export const SettingsAndLoads = [
//   RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_LOADS?.code], 'agentView') &&
//   {
//     'name': 'Loads',
//     'icon': Images.loads,
//     'activeIcon': Images.activeLoad,
//     'create': '/create-load',
//     'path': '/loads',
//   },
//
//   {
//     'name': 'Truck Board',
//     'icon': Images.truckBoard,
//     'activeIcon': Images.truckBoardFill,
//     // "create": "/trucks",
//     'path': '/trucks',
//   },
//
//
// ];


// export const FactoredCreditLoads = (total) => {
//
//   return [
//     {
//       'name': 'Credit Check',
//       'icon': Images.creditCheck,
//       'activeIcon': Images.creditCheckActive,
//       'create': '/credit',
//       'path': '/credit',
//       'activeCount': total?.numCreditRequests + total?.numConsignmentRequest,
//     },
//     {
//       'name': 'Rejected',
//       'icon': Images.rejectedCredit,
//       'activeIcon': Images.rejectedCreditActive,
//       'create': '/rejected',
//       'path': '/rejected',
//     },
//     // {
//     //   'name': 'Consignment Request',
//     //   'icon': Images.consign,
//     //   'activeIcon': Images.consignActive,
//     //   'create': '/consignmentRequest',
//     //   'path': '/consignmentRequest',
//     //   'activeCount': total?.numConsignmentRequest,
//     // },
//     {
//       'name': 'Consignment',
//       'icon': Images.consignementPassive,
//       'activeIcon': Images.consignementActive,
//       'create': '/consign',
//       'path': '/consign',
//     },
//   ];
// };

// export const CreditLoads = (total) => {
//
//   return [
//     RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.ACCEPT_DENY_LOAD?.code, PermissionsList.CREDIT_TAB?.code], 'agentView') &&
//     {
//       'name': 'Credit Check',
//       'icon': Images.creditCheck,
//       'activeIcon': Images.creditCheckActive,
//       'create': '/credit',
//       'path': '/credit',
//       'activeCount': total?.numCreditRequests + total?.numConsignmentRequest,
//     },
//     RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.CREDIT_TAB?.code], 'agentView') &&
//     {
//       'name': 'Rejected',
//       'icon': Images.rejectedCredit,
//       'activeIcon': Images.rejectedCreditActive,
//       'create': '/rejected',
//       'path': '/rejected',
//     },
//     // RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.CREDIT_CONSIGN_TAB?.code, PermissionsList.ACCEPT_DENY_CONSIGN_LOAD?.code], 'officeOrBranchManager') &&
//     // {
//     //   'name': 'Consignment Request',
//     //   'icon': Images.consign,
//     //   'activeIcon': Images.consignActive,
//     //   'create': '/consignmentRequest',
//     //   'path': '/consignmentRequest',
//     //   'activeCount': total?.numConsignmentRequest,
//     // },
//     RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.CREDIT_CONSIGN_TAB?.code], 'officeOrBranchManager') &&
//     {
//       'name': 'Consignment',
//       'icon': Images.consignementPassive,
//       'activeIcon': Images.consignementActive,
//       'create': '/consign',
//       'path': '/consign',
//     },
//   ];
// };


export const Claims = (total) => {
  return [
    RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_BOND_LIST.code], 'officeOrBranchManager') &&
    {
      'name': 'Bonds',
      'icon': Images.onBondPassive,
      'activeIcon': Images.onBondActive,
      'path': '/bonds',
    },
    RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_CLAIM_LIST.code], 'officeOrBranchManager') &&
    {
      'name': 'Claims',
      'icon': Images.onClaimPassive,
      'activeIcon': Images.onClaimActive,
      'path': '/claims',
    },
  ];
};

// export const LoadAccounting = () => {
//   if (userType === 'AGENT') {
//     return [
//       // {
//       //     "name": "Receivables",
//       //     "icon": "Receivables",
//       //     "path": "/receivables",
//       //     "create": "/receivables",
//       // },
//
//       // {
//       //     "name": "Carrier Payment",
//       //     "icon": "CarrierPayment",
//       //     "path": "/carrierPayments",
//       //     "create": "/carrierPayments",
//       // },
//     ];
//   } else if (userType === 'ADMIN') {
//     return [
//
//       RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_PROCESSING?.code]) &&
//       {
//         'name': 'Processing',
//         'icon': Images.processingGray,
//         'activeIcon': Images.processingFill,
//         'path': '/processing',
//         'create': '/processing',
//       },
//       RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_LOAD_VERIFICATION?.code]) &&
//       {
//         'name': 'Load Verification',
//         'icon': Images.loadVerification,
//         'activeIcon': Images.loadVerificationFill,
//         'path': '/loadVerification',
//         'create': '/loadVerification',
//       },
//
//       RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_PAYMENT_VERIFICATION?.code]) &&
//       {
//         'name': 'Pmt Verification',
//         'icon': Images.paymentVerification,
//         'activeIcon': Images.paymentVerificationFill,
//         'path': '/paymentVerification',
//         'create': '/paymentVerification',
//       },
//       RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_PAYABLE?.code]) &&
//       {
//         'name': 'Payables',
//         'icon': Images.payable,
//         'activeIcon': Images.payableFill,
//         'path': '/payables',
//         'create': '/payables',
//       },
//
//       RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.SUBMIT_BILL?.code, PermissionsList.READ_BILLING?.code]) &&
//       {
//         'name': 'Billing',
//         'icon': Images.billingGray,
//         'activeIcon': Images.billingFill,
//         'path': '/billing',
//         'create': '/billing',
//       },
//       RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_RECEIVABLES?.code]) &&
//       {
//         'name': 'Receivables',
//         'icon': Images.receivables,
//         'activeIcon': Images.receivablesFill,
//         'path': '/receivables',
//         'create': '/receivables',
//       },
//       RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_CARRIER_PAYMENT?.code]) &&
//       {
//         'name': 'Carrier Payments',
//         'icon': Images.carrierPayment,
//         'activeIcon': Images.carrierPaymentFill,
//         'path': '/carrierPayments',
//         'create': '/carrierPayments',
//       },
//       RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_CUSTOMER_PAYMENT?.code, PermissionsList.CREATE_CUSTOMER_PAYMENT?.code]) &&
//       {
//         'name': 'Customer Payments',
//         'icon': Images.customerPayment,
//         'activeIcon': Images.customerPaymentFill,
//         'path': '/customerPayments',
//         'create': '/customerPayments',
//       },
//
//
//     ];
//   }
// };

// export const Payroll = [
//   RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_PAYROLL?.code], 'agentView') &&
//   {
//     'name': 'Payroll',
//     'icon': Images.payroll,
//     'activeIcon': Images.payrollActive,
//     'detail': '/template',
//     'path': '/payroll',
//   },
//   // RolePermission([PermissionsList.READ_MANAGEMENT?.code]) &&
//   // {
//   //   'name': 'Access',
//   //   'icon': Images.accessManagementGray,
//   //   'activeIcon': Images.accessManagement,
//   //   'path': '/management',
//   // },
//
//   {
//     'name': 'Directory',
//     'icon': Images.directory,
//     'activeIcon': Images.directoryActive,
//     'path': '/directory',
//     'type': 'Profile',
//   },
//   userType === 'ADMIN' && RolePermission([
//     PermissionsList.CREATE_UPDATE_MY_CONF?.code,
//     PermissionsList.CREATE_UPDATE_PAYROLL_SETUP?.code,
//     PermissionsList.READ_PAYROLL_SETUP?.code,
//     PermissionsList.READ_MY_CONF?.code,
//     PermissionsList.READ_MANAGEMENT?.code,
//   ]) &&
//   {
//     'name': 'System',
//     'icon': Images.systemGray,
//     'activeIcon': Images.systemFill,
//     'create': '/system',
//     'path': '/system',
//   },
//   userType !== 'ADMIN' &&
//   {
//     'name': 'Load Templates',
//     'icon': Images.templatePassive,
//     'activeIcon': Images.templateActive,
//     'create': '/templates',
//     'detail': '/template',
//     'path': '/templates',
//   },
//
// ];


// export const AllRouting = [
//   {
//     'name': 'Offices',
//     'path': '/offices',
//   },
//   {
//     'name': 'Add Office',
//     'path': '/createOffice',
//   },
//   {
//     'name': 'Branches',
//     'path': '/branches',
//   },
//   {
//     'name': 'Add Branch',
//     'path': '/createBranch',
//   },
//   {
//     'name': 'Human Resources',
//     'path': '/humanResources',
//   },
//   {
//     'name': 'Add Human Resource',
//     'path': '/createHumanResources',
//   },
//   {
//     'name': 'Customers',
//     'path': '/customers',
//   },
//   {
//     'name': 'Add Customers',
//     'path': '/createCustomer',
//   },
//   {
//     'name': 'Factoring Companies',
//     'path': '/factorings',
//   },
//   {
//     'name': 'Add Factoring Companie',
//     'path': '/createFactoring',
//   },
//   {
//     'name': 'Authorities',
//     'path': '/authorities',
//   },
//   {
//     'name': 'Add MC Authoritie',
//     'path': '/createAuthorities',
//   },
//   {
//     'name': 'Carriers',
//     'path': '/Carriers',
//   },
//   {
//     'name': 'Vendors',
//     'path': '/vendors',
//   },
//   {
//     'name': 'Add Carrier',
//     'path': '/createCarrier',
//   },
//
//   {
//     'name': 'Agents',
//     'path': '/agents',
//   },
//   {
//     'name': 'Add Agent',
//     'path': '/createAgent',
//   },
//   {
//     'name': 'Processing',
//     'path': '/processing',
//   },
//   {
//     'name': 'Billing',
//     'path': '/billing',
//   },
//   {
//     'name': 'Receivables',
//     'path': '/receivables',
//   },
//   {
//     'name': 'Customer Payment',
//     'path': '/customerPayments',
//   },
//   {
//     'name': 'Load Verification',
//     'path': '/loadVerification',
//   },
//   {
//     'name': 'Payment Verification',
//     'path': '/paymentVerification',
//   },
//   {
//     'name': 'Payables',
//     'path': '/payables',
//   },
//   {
//     'name': 'Carrier Payment',
//     'path': '/carrierPayments',
//   },
//   {
//     'name': 'Receivables',
//     'path': '/receivables',
//   },
//   {
//     'name': 'Payroll',
//     'path': '/payroll',
//   },
//   // {
//   //   'name': 'Access Management',
//   //   'path': '/management',
//   // },
//   {
//     'name': 'Loads',
//     'path': '/loads',
//   },
//   {
//     'name': 'Add Load',
//     'path': '/create-load',
//   },
//   {
//     'name': 'System',
//     'path': '/system',
//   },
//   {
//     'name': 'Credit Check',
//     'path': '/credit',
//   },
//   {
//     'name': 'Rejected',
//     'path': '/rejected',
//   },
//   // {
//   //   'name': 'Consignment Request',
//   //   'path': '/consignmentRequest',
//   // },
//   {
//     'name': 'Consignment',
//     'path': '/consign',
//   },
//   {
//     'name': 'Claims',
//     'path': '/claims',
//   },
//   {
//     'name': 'Bonds',
//     'path': '/bonds',
//   },
//   {
//     'name': 'Ar Report',
//     'path': '/ar',
//   },
//   {
//     'name': 'Ap Report',
//     'path': '/ap',
//   },
//   {
//     'name': 'Load Templates',
//     'path': '/templates',
//   },
//   {
//     'name': 'Truck Board',
//     'path': '/trucks',
//   },
//   {
//     'name': 'My Profile',
//     'path': '/my-profile',
//   },
//   {
//     'name': 'Add Factored Load',
//     'path': '/create-factored-load',
//   },
//
// ];

// export const reportActions = [
//   {
//     'name': 'AR',
//     'icon': Images.arIcon,
//     'activeIcon': Images.arActive,
//     'path': '/ar',
//   },
//   {
//     'name': 'AP',
//     'icon': Images.apPassive,
//     'activeIcon': Images.apActive,
//     'path': '/ap',
//   },
// ];



// export const RoutingAllListNew = (total) => {
//   return isFactored ? [
//       {
//         'name': 'My Profile',
//         'icon': Images.profilesGray,
//         'activeIcon': Images.profilesFill,
//         'path': '/my-profile',
//       },
//
//       {
//         'name': 'Orders',
//         'icon': Images.loads,
//         'activeIcon': Images.activeLoad,
//         'create': '/create-load',
//         'path': '/loads',
//         'pathsList': ['/loads', '/create-load' , '/load-group', 'load', 'grouped-load'],
//       },
//       {
//         'name': 'Credit Management',
//         'icon': Images.creditFill,
//         'activeIcon': Images.creditFillBold,
//         'type': 'accordion',
//         'activeCount': total,
//         pathsList: ['/credit', '/rejected', '/consign'],
//         list:
//           [
//             {
//               'name': 'Credit Check',
//               'icon': Images.creditCheck,
//               'activeIcon': Images.creditCheckActive,
//               'create': '/credit',
//               'path': '/credit',
//               'activeCount': total,
//             },
//             {
//               'name': 'Rejected',
//               'icon': Images.rejectedCredit,
//               'activeIcon': Images.rejectedCreditActive,
//               'create': '/rejected',
//               'path': '/rejected',
//             },
//             {
//               'name': 'Consignment',
//               'icon': Images.consignementPassive,
//               'activeIcon': Images.consignementActive,
//               'create': '/consign',
//               'path': '/consign',
//             },
//           ],
//       },
//     ]
//     :
//     [
//       isAgent &&
//       {
//         'name': 'My Profile',
//         'icon': Images.profilesGray,
//         'activeIcon': Images.profilesFill,
//         'path': '/my-profile',
//       },
//
//       {
//         'name': 'Profiles',
//         'icon': Images.profilesGray,
//         'activeIcon': Images.profilesFill,
//         'type': 'accordion',
//         pathsList: [
//           '/humanResources', '/humanResource', '/createHumanResources', '/offices', '/office', '/createOffice', '/branches', '/branch', '/createBranch',
//           '/agents', '/agent', '/createAgent', '/authorities', '/authority', '/createAuthorities', '/customers','/customer', '/createCustomer',
//           '/vendors','/vendor', '/create-vendor', '/factorings','/factoring', '/createFactoring',
//         ],
//         list: [
//           userType === 'ADMIN' &&
//           RolePermission([PermissionsList.READ_ADMIN?.code, PermissionsList.CREATE_UPDATE_ADMIN?.code]) &&
//           {
//             'name': 'HR',
//             'icon': Images.humanResourcesGray,
//             'activeIcon': Images.humanResources,
//             'path': '/humanResources',
//             'create': '/createHumanResources',
//             'detail': '/humanResource',
//             'type': 'Profile',
//           },
//           RolePermission([PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code], 'officeManager') &&
//           {
//             'name': 'Offices',
//             'icon': Images.officesGray,
//             'activeIcon': Images.offices,
//             'path': '/offices',
//             'create': '/createOffice',
//             'info': '/office',
//             'detail': '/office',
//             'type': 'Profile',
//           },
//           RolePermission([PermissionsList.READ_BRANCH?.code, PermissionsList.CREATE_UPDATE_BRANCH?.code], 'officeOrBranchManager') &&
//           {
//             'name': 'Regional Offices',
//             'icon': Images.branchesGray,
//             'activeIcon': Images.branches,
//             'path': '/branches',
//             'create': '/createBranch',
//             'detail': '/branch',
//             'type': 'Profile',
//           },
//           RolePermission([PermissionsList?.READ_AGENT?.code, PermissionsList.CREATE_UPDATE_AGENT?.code], 'officeOrBranchManager') &&
//           {
//             'name': 'Users',
//             'icon': Images.agentsGray,
//             'activeIcon': Images.agentsFill,
//             'path': '/agents',
//             'create': '/createAgent',
//             'detail': '/agent',
//             'type': 'Profile',
//           },
//           RolePermission([PermissionsList.READ_MC?.code, PermissionsList.CREATE_UPDATE_MC?.code]) &&
//           {
//             'name': 'Authorities',
//             'icon': Images.authorityGray,
//             'activeIcon': Images.authorityFill,
//             'path': '/authorities',
//             'create': '/createAuthorities',
//             'detail': '/authority',
//             'type': 'Profile',
//           },
//           userType === 'ADMIN' &&
//           RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) &&
//           {
//             'name': 'Customers',
//             'icon': Images.customerGray,
//             'activeIcon': Images.customerFill,
//             'path': '/customers',
//             'create': '/createCustomer',
//             'detail': '/customer',
//             'type': 'Profile',
//           },
//           RolePermission([PermissionsList?.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code], 'agentView') &&
//           {
//             'name': 'Vendors',
//             'icon': Images.vendorGray,
//             'activeIcon': Images.vendorFill,
//             'path': '/vendors',
//             'create': '/create-vendor',
//             'detail': '/vendor',
//             'type': 'Profile',
//           },
//           userType === 'ADMIN' &&
//           RolePermission([PermissionsList.READ_FACTORING?.code, PermissionsList.CREATE_UPDATE_FACTORING?.code]) &&
//           {
//             'name': 'Factorings',
//             'icon': Images.factoringGray,
//             'activeIcon': Images.factoring,
//             'path': '/factorings',
//             'create': '/createFactoring',
//             'detail': '/factoring',
//             'type': 'Profile',
//           },
//         ],
//       },
//
//
//       RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_LOADS?.code], 'agentView') &&
//       {
//         'name': 'Orders',
//         'icon': Images.loads,
//         'activeIcon': Images.activeLoad,
//         'create': '/create-load',
//         'path': '/loads',
//         'pathsList': ['/loads', '/create-load' , '/load-group', 'load', 'grouped-load'],
//       },
//
//       {
//         'name': 'Vendor Board',
//         'icon': Images.truckBoard,
//         'activeIcon': Images.truckBoardFill,
//         'type': 'accordion',
//         pathsList: ['/prospects', '/trucks'],
//         list: [
//           {
//             'name': 'Vendor Board',
//             'icon': Images.truckBoard,
//             'activeIcon': Images.truckBoardFill,
//             'path': '/trucks',
//             'type':'Vendor Board',
//           },
//           {
//             'name': 'Vendor Prospects',
//             'icon': Images.vendorProspects,
//             'activeIcon': Images.vendorProspectsActive,
//             'path': '/prospects',
//             'type':'Vendor Board',
//           },
//         ]
//       },
//
//       isAdmin &&
//       {
//         'name': 'Accounting',
//         'icon': Images.accountingGray,
//         'activeIcon': Images.accountingFill,
//         'type': 'accordion',
//         pathsList: ['/processing', '/loadVerification', '/paymentVerification', '/payables', '/billing', '/receivables', '/carrierPayments', '/customerPayments','/customerPayment', '/collections'],
//
//         list: [
//           RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_PROCESSING?.code]) &&
//           {
//             'name': 'Processing',
//             'icon': Images.processingGray,
//             'activeIcon': Images.processingFill,
//             'path': '/processing',
//             'create': '/processing',
//           },
//           RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_LOAD_VERIFICATION?.code]) &&
//           {
//             'name': 'Load Verification',
//             'icon': Images.loadVerification,
//             'activeIcon': Images.loadVerificationFill,
//             'path': '/loadVerification',
//             'create': '/loadVerification',
//           },
//
//           RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_PAYMENT_VERIFICATION?.code]) &&
//           {
//             'name': 'Pmt Verification',
//             'icon': Images.paymentVerification,
//             'activeIcon': Images.paymentVerificationFill,
//             'path': '/paymentVerification',
//             'create': '/paymentVerification',
//           },
//           RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_PAYABLE?.code]) &&
//           {
//             'name': 'Payables',
//             'icon': Images.payable,
//             'activeIcon': Images.payableFill,
//             'path': '/payables',
//             'create': '/payables',
//           },
//
//           RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.SUBMIT_BILL?.code, PermissionsList.READ_BILLING?.code]) &&
//           {
//             'name': 'Billing',
//             'icon': Images.billingGray,
//             'activeIcon': Images.billingFill,
//             'path': '/billing',
//             'create': '/billing',
//           },
//           RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_RECEIVABLES?.code]) &&
//           {
//             'name': 'Receivables',
//             'icon': Images.receivables,
//             'activeIcon': Images.receivablesFill,
//             'path': '/receivables',
//             'create': '/receivables',
//           },
//           RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_CARRIER_PAYMENT?.code]) &&
//           {
//             'name': 'Carrier Payments',
//             'icon': Images.carrierPayment,
//             'activeIcon': Images.carrierPaymentFill,
//             'path': '/carrierPayments',
//             'create': '/carrierPayments',
//           },
//           RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_CUSTOMER_PAYMENT?.code, PermissionsList.CREATE_CUSTOMER_PAYMENT?.code]) &&
//           {
//             'name': 'Customer Payments',
//             'icon': Images.customerPayment,
//             'activeIcon': Images.customerPaymentFill,
//             'path': '/customerPayments',
//             'detail':'/customerPayment',
//             'create': '/customerPayments',
//           },
//
//           RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_COLLECTIONS?.code]) &&
//           {
//             'name': 'Collection',
//             'path': '/collections',
//             // 'icon': Images.customerPayment,
//             // 'activeIcon': Images.collectionFill,
//             // 'detail':'/customerPayment',
//             // 'create': '/customerPayments',
//           },
//         ],
//       },
//
//       {
//         'name': 'Credit Management',
//         'icon': Images.creditFill,
//         'activeIcon': Images.creditFillBold,
//         'type': 'accordion',
//         'activeCount': total,
//         pathsList: ['/credit', '/rejected', '/consign'],
//         list:
//           [
//             {
//               'name': 'Credit',
//               'icon': Images.creditCheck,
//               'activeIcon': Images.creditCheckActive,
//               'create': '/credit',
//               'path': '/credit',
//               'activeCount': total,
//             },
//             {
//               'name': 'Rejected',
//               'icon': Images.rejectedCredit,
//               'activeIcon': Images.rejectedCreditActive,
//               'create': '/rejected',
//               'path': '/rejected',
//             },
//             {
//               'name': 'Consignment',
//               'icon': Images.consignementPassive,
//               'activeIcon': Images.consignementActive,
//               'create': '/consign',
//               'path': '/consign',
//             },
//           ],
//       },
//
//
//
//       isAdmin &&
//       {
//         'name': 'Risk Management',
//         'icon': Images.claimGray,
//         'activeIcon': Images.claimFill,
//         'type': 'accordion',
//         pathsList: ['/bonds', '/claims'],
//
//         list: [
//           RolePermission([PermissionsList.READ_BOND_LIST.code], 'officeOrBranchManager') &&
//           {
//             'name': 'Bonds',
//             'icon': Images.onBondPassive,
//             'activeIcon': Images.onBondActive,
//             'path': '/bonds',
//           },
//           RolePermission([PermissionsList.READ_CLAIM_LIST.code], 'officeOrBranchManager') &&
//           {
//             'name': 'Claims',
//             'icon': Images.onClaimPassive,
//             'activeIcon': Images.onClaimActive,
//             'path': '/claims',
//           },
//         ],
//       },
//
//       RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_PAYROLL?.code], 'agentView') &&
//       {
//         'name': 'Sales Analytics',
//         'icon': Images.payroll,
//         'activeIcon': Images.payrollActive,
//         'path': '/payroll',
//       },
//       userType !== 'ADMIN' &&
//       {
//         'name': 'Load Templates',
//         'icon': Images.templatePassive,
//         'activeIcon': Images.templateActive,
//         'create': '/templates',
//         'detail': '/template',
//         'path': '/templates',
//       },
//
//       isAdmin &&
//       {
//         'name': 'Financials',
//         'icon': Images.reports,
//         'activeIcon': Images.activeReports,
//         'type': 'accordion',
//         pathsList: ['/ar', '/ap'],
//
//         list: [
//           {
//             'name': 'AR',
//             'icon': Images.arIcon,
//             'activeIcon': Images.arActive,
//             'path': '/ar',
//           },
//           {
//             'name': 'AP',
//             'icon': Images.apPassive,
//             'activeIcon': Images.apActive,
//             'path': '/ap',
//           },
//         ],
//       },
//
//       {
//         'name': 'Directory',
//         'icon': Images.directory,
//         'activeIcon': Images.directoryActive,
//         'path': '/directory',
//       },
//       {
//         'name': 'Leaderboard',
//         'icon': Images.leaderboard,
//         'activeIcon': Images.leaderboardActive,
//         'path': '/leaderboard',
//       },
//       isAdmin && RolePermission([
//         PermissionsList.CREATE_UPDATE_MY_CONF?.code,
//         PermissionsList.CREATE_UPDATE_PAYROLL_SETUP?.code,
//         PermissionsList.READ_PAYROLL_SETUP?.code,
//         PermissionsList.READ_MY_CONF?.code,
//         PermissionsList.READ_MANAGEMENT?.code,
//       ]) &&
//       {
//         'name': 'System',
//         'icon': Images.systemGray,
//         'activeIcon': Images.systemFill,
//         'create': '/system',
//         'path': '/system',
//       },
//     ];
//
// };
export const RoutingAllListNew = (total) => {
  return (
    [
      {
        'name': 'Dashboard',
        'icon': Images.dashboardPassive,
        'activeIcon': Images.creditFillBold,
        'type': 'accordion',
        pathsList: ['/my-profile', '/leaderboard', '/templates'],
        list:
          [
            (isAgent || isFactored) &&
            {
              'name': 'My Profile',
              'path': '/my-profile',
            },
            (isAgent || isAdmin) &&
            {
              'name': 'Leaderboard',
              'path': '/leaderboard',
            },
            isAgent &&
            {
              'name': 'Order Templates',
              'create': '/templates',
              'detail': '/template',
              'path': '/templates',
            },
          ],
      },

      !isFactored &&
      {
        'name': 'Profiles',
        'icon': Images.profilesGray,
        'activeIcon': Images.profilesFill,
        'type': 'accordion',
        pathsList: [
          '/humanResources', '/humanResource', '/createHumanResources', '/offices', '/office', '/createOffice', '/branches', '/branch', '/createBranch',
          '/agents', '/agent', '/createAgent', '/authorities', '/authority', '/createAuthorities', '/customers','/customer', '/createCustomer',
          '/vendors','/vendor', '/create-vendor', '/factorings','/factoring', '/createFactoring',
        ],
        list: [
          userType === 'ADMIN' &&
          RolePermission([PermissionsList.READ_ADMIN?.code, PermissionsList.CREATE_UPDATE_ADMIN?.code]) &&
          {
            'name': 'HR',
            'path': '/humanResources',
            'create': '/createHumanResources',
            'detail': '/humanResource',
            'type': 'Profile',
          },
          RolePermission([PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code], 'officeManager') &&
          {
            'name': 'Offices',
            'path': '/offices',
            'create': '/createOffice',
            'info': '/office',
            'detail': '/office',
            'type': 'Profile',
          },
          RolePermission([PermissionsList.READ_BRANCH?.code, PermissionsList.CREATE_UPDATE_BRANCH?.code], 'officeOrBranchManager') &&
          {
            'name': 'Regional Offices',
            'path': '/branches',
            'create': '/createBranch',
            'detail': '/branch',
            'type': 'Profile',
          },
          RolePermission([PermissionsList?.READ_AGENT?.code, PermissionsList.CREATE_UPDATE_AGENT?.code], 'officeOrBranchManager') &&
          {
            'name': 'Users',
            'path': '/agents',
            'create': '/createAgent',
            'detail': '/agent',
            'type': 'Profile',
          },
          RolePermission([PermissionsList.READ_MC?.code, PermissionsList.CREATE_UPDATE_MC?.code]) &&
          {
            'name': 'Authorities',
            'path': '/authorities',
            'create': '/createAuthorities',
            'detail': '/authority',
            'type': 'Profile',
          },
          userType === 'ADMIN' &&
          RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) &&
          {
            'name': 'Customers',
            'path': '/customers',
            'create': '/createCustomer',
            'detail': '/customer',
            'type': 'Profile',
          },
          RolePermission([PermissionsList?.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code], 'agentView') &&
          {
            'name': 'Vendors',
            'path': '/vendors',
            'create': '/create-vendor',
            'detail': '/vendor',
            'type': 'Profile',
          },
          RolePermission([PermissionsList.READ_FACTORING?.code, PermissionsList.CREATE_UPDATE_FACTORING?.code]) && isAdmin &&
          {
            'name': 'Factoring',
            'path': '/factorings',
            'create': '/createFactoring',
            'detail': '/factoring',
            'type': 'Profile',
          },
        ],
      },


      (RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_LOADS?.code], 'agentView') || isFactored) &&
      {
        'name': 'Orders',
        'icon': Images.loads,
        'activeIcon': Images.activeLoad,
        'create': '/create-load',
        'path': '/loads',
        'pathsList': ['/loads', '/create-load' , '/load-group', 'load', 'grouped-load'],
      },

      !isFactored &&
      {
        'name': 'Vendor Relations',
        'icon': Images.truckBoard,
        'activeIcon': Images.truckBoardFill,
        'type': 'accordion',
        pathsList: ['/prospects', '/trucks'],
        list: [
          {
            'name': 'Vendor Board',
            'path': '/trucks',
            'type':'Vendor Board',
          },
          {
            'name': 'Vendor Prospects',
            'path': '/prospects',
            'type':'Vendor Board',
          },
        ]
      },

      (isAdmin || isFactored || officeManager || branchManager) &&
      {
        'name': 'Accounting',
        'icon': Images.accountingGray,
        'activeIcon': Images.accountingFill,
        'type': 'accordion',
        pathsList: [
          '/processing', '/loadVerification', '/paymentVerification', '/payables', '/billing',
          '/receivables', '/bad-debt', '/carrierPayments', '/customerPayments','/customerPayment',
          '/collections', '/vendor-reserve', '/short-overpays'
        ],

        list: [
          RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_PROCESSING?.code]) &&
          {
            'name': 'Processing',
            'path': '/processing',
            'create': '/processing',
          },
          RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_LOAD_VERIFICATION?.code]) &&
          {
            'name': 'Order Verification',
            'path': '/loadVerification',
            'create': '/loadVerification',
          },
          RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_PAYMENT_VERIFICATION?.code]) &&
          {
            'name': 'Payable Verification',
            'path': '/paymentVerification',
            'create': '/paymentVerification',
          },
          RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_COLLECTIONS?.code]) &&
          {
            'name': 'Vendor Collections',
            'path': '/collections',
          },
          (RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_COLLECTIONS?.code]) || isFactored) &&
          {
            'name': 'Vendor Reserve',
            'path': '/vendor-reserve',
          },
          RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_PAYABLE?.code]) &&
          {
            'name': 'Accounts Payable',
            'path': '/payables',
            'create': '/payables',
          },
          RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.SUBMIT_BILL?.code, PermissionsList.READ_BILLING?.code]) &&
          {
            'name': 'Billing',
            'path': '/billing',
            'create': '/billing',
          },
          (RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_RECEIVABLES?.code], 'officeOrBranchManager') || isFactored) &&
          {
            'name': 'Accounts Receivable',
            'path': '/receivables',
            'create': '/receivables',
          },
          (RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_RECEIVABLES?.code], 'officeOrBranchManager') || isFactored) &&
          {
            'name': 'Bad Debt',
            'path': '/bad-debt',
            'create': '/bad-debt',
          },
          RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_CARRIER_PAYMENT?.code]) &&
          {
            'name': 'Vendor Payments',
            'path': '/carrierPayments',
            'create': '/carrierPayments',
          },
          RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_CUSTOMER_PAYMENT?.code, PermissionsList.CREATE_CUSTOMER_PAYMENT?.code]) &&
          {
            'name': 'Customer Payments',
            'path': '/customerPayments',
            'detail':'/customerPayment',
            'create': '/customerPayments',
          },
          RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.MANAGE_CUSTOMER_OVERPAYS?.code]) &&
          {
            'name': 'Short/Overpays',
            'path': '/short-overpays',
          },
        ],
      },


      isAdmin &&
        RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_CORPORATE_TXNS?.code]) &&
      {
        'name': 'Corporate Transactions',
        'icon': Images.corporateTxns,
        'path': '/corporate-transactions',
      },


      {
        'name': 'Credit Management',
        'icon': Images.creditFill,
        'activeIcon': Images.creditFillBold,
        'type': 'accordion',
        'activeCount': total,
        pathsList: ['/credit', '/rejected', '/consign'],
        list:
          [
            {
              'name': 'Credit',
              'create': '/credit',
              'path': '/credit',
              'activeCount': total,
            },
            {
              'name': 'Rejected',
              'create': '/rejected',
              'path': '/rejected',
            },
            {
              'name': 'Consignment',
              'create': '/consign',
              'path': '/consign',
            },
          ],
      },

      isAdmin &&
      {
        'name': 'Risk Management',
        'icon': Images.claimGray,
        'activeIcon': Images.claimFill,
        'type': 'accordion',
        pathsList: ['/bonds', '/claims'],

        list: [
          RolePermission([PermissionsList.READ_BOND_LIST.code], 'officeOrBranchManager') &&
          {
            'name': 'Bonds',
            'path': '/bonds',
          },
          RolePermission([PermissionsList.READ_CLAIM_LIST.code], 'officeOrBranchManager') &&
          {
            'name': 'Claims',
            'path': '/claims',
          },
        ],
      },

      RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_PAYROLL?.code], 'agentView') &&
      {
        'name': 'Sales Analytics',
        'icon': Images.payroll,
        'activeIcon': Images.payrollActive,
        'path': '/payroll',
      },


      // RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_PAYROLL?.code], 'agentView') &&
      // {
      //   'name': 'Payroll',
      //   'icon': Images.payroll,
      //   'activeIcon': Images.payrollActive,
      //   'type': 'accordion',
      //   pathsList: ['/payroll'],
      //
      //   list: [
      //     RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_PAYROLL?.code], 'agentView') &&
      //     {
      //       'name': 'Sales Analytics',
      //       'path': '/payroll',
      //     },
      //   ],
      // },


      //  Must be Analytics

      isAdmin &&
      {
        'name': 'Analytics',
        'icon': Images.analyticsFill,
        'activeIcon': Images.payrollActive,
        'path': '/analytics',
      },

      isAdmin &&
      {
        'name': 'Financials',
        'icon': Images.reports,
        'activeIcon': Images.activeReports,
        'type': 'accordion',
        pathsList: ['/ar', '/ap'],

        list: [
          {
            'name': 'AR',
            'path': '/ar',
          },
          {
            'name': 'AP',
            'path': '/ap',
          },
        ],
      },

      !isFactored &&
      {
        'name': 'Directory',
        'icon': Images.directory,
        'activeIcon': Images.directoryActive,
        'path': '/directory',
      },

      isAdmin && RolePermission([
        PermissionsList.CREATE_UPDATE_MY_CONF?.code,
        PermissionsList.CREATE_UPDATE_PAYROLL_SETUP?.code,
        PermissionsList.READ_PAYROLL_SETUP?.code,
        PermissionsList.READ_MY_CONF?.code,
        PermissionsList.READ_MANAGEMENT?.code,
      ]) &&
      {
        'name': 'System',
        'icon': Images.systemGray,
        'activeIcon': Images.systemFill,
        'create': '/system',
        'path': '/system',
      },

      !isFactored &&
      {
        'name': 'Resource Center',
        'icon': Images.resourceCenter,
        'activeIcon': Images.resourceCenterActive,
        'path': '/resource',
        pathsList: ['/resource/'],
      },
    ]
)
};
